import { Field } from 'formik';
import { RadioGroup } from 'formik-material-ui';
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
} from '@material-ui/core';
import { OFF, ON } from 'consts';

const radio = <Radio color="primary" />;

const ContentBillerAccountActive = () => {
  return (
    <FormControl>
      <FormLabel>
        Is the user&apos;s account with this biller currently active?
      </FormLabel>
      <Field component={RadioGroup} name="paymentPostedToActiveBillerOffOn" row>
        <FormControlLabel control={radio} label="Yes" value={ON} />
        <FormControlLabel control={radio} label="No" value={OFF} />
      </Field>
    </FormControl>
  );
};

export default ContentBillerAccountActive;
